module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#rss",
      toString: function () {
        return this.url;
      }
    }